var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingAvatarAlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 135.847C107.292 135.847 135.847 107.25 135.847 72C135.847 36.7082 107.249 8.15277 72 8.15277C36.7082 8.15277 8.15277 36.7505 8.15277 72C8.11053 107.292 36.7082 135.847 72 135.847Z",
    fill: "#E0DDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6071_8179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 128,
    height: 128
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 135.847C107.292 135.847 135.847 107.25 135.847 72C135.847 36.7082 107.249 8.15277 72 8.15277C36.7082 8.15277 8.15277 36.7505 8.15277 72C8.11053 107.292 36.7082 135.847 72 135.847Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6071_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4531 120.438C29.7193 120.69 30.0277 120.947 30.2939 121.198C30.6024 121.455 30.8686 121.707 31.1829 121.922C31.455 122.131 31.6848 122.334 31.9569 122.542C31.9932 122.591 32.0355 122.596 32.0718 122.645C32.9608 123.368 33.8979 124.054 34.8408 124.699C35.1129 124.908 35.4272 125.123 35.7052 125.29C35.7052 125.29 35.7416 125.338 35.7838 125.344C36.0981 125.559 36.4125 125.773 36.7268 125.988C37.3554 126.418 38.0322 126.811 38.6658 127.199C38.9801 127.413 39.3426 127.592 39.6628 127.765C39.983 127.938 40.3396 128.158 40.6588 128.331C40.979 128.504 41.3356 128.725 41.6558 128.897C41.6558 128.897 41.6558 128.897 41.698 128.903C42.0182 129.075 42.3797 129.254 42.6999 129.427C43.4248 129.784 44.191 130.146 44.9159 130.504C45.1576 130.623 45.4404 130.747 45.6821 130.866C46.4489 131.229 47.2213 131.55 47.9994 131.828C48.2831 131.953 48.5726 132.035 48.8984 132.166C49.6343 132.439 50.4126 132.717 51.1485 132.99C51.3114 133.055 51.438 133.072 51.6008 133.137C51.8482 133.214 52.1375 133.296 52.3848 133.374C52.7586 133.467 53.0844 133.598 53.4582 133.692C53.621 133.758 53.7898 133.781 53.9527 133.845C54.1577 133.917 54.405 133.994 54.658 134.028C55.3212 134.205 56.0266 134.388 56.6898 134.564C56.8948 134.635 57.1479 134.669 57.353 134.741L57.3952 134.747C57.6846 134.83 57.9797 134.87 58.2692 134.952C58.5586 135.035 58.8539 135.075 59.149 135.115C59.3177 135.139 59.5228 135.21 59.6915 135.233C60.0289 135.279 60.3183 135.362 60.6135 135.402C61.0352 135.46 61.4089 135.554 61.8307 135.611C62.2524 135.669 62.6319 135.721 63.0536 135.779C63.3489 135.82 63.6441 135.86 63.9392 135.9C81.7281 138.078 98.7867 132.724 111.813 122.306C111.813 122.306 111.818 122.263 111.861 122.269C110.905 119.518 106.691 114.215 102.156 109.685C96.4096 103.957 87.7527 99.7215 87.7527 99.7215C87.7527 99.7215 81.9393 97.9377 59.2543 99.5152C41.9426 100.754 32.8046 114.153 29.4531 120.438Z",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9732 110.556C53.2642 115.02 58.6473 118.379 68.8357 115.821C81.3441 112.635 87.7519 99.7215 87.7519 99.7215C89.7124 90.1091 92.3258 82.0034 92.3258 82.0034C78.7817 78.9462 60.3939 92.7543 60.3939 92.7543L57.4529 100.429C57.192 101.08 56.7737 101.624 56.2099 101.977C55.1164 103.374 52.7639 107.692 52.9732 110.556Z",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.205 102.019C64.3175 102.7 70.4253 102.333 78.3579 91.7764C72.3076 95.8027 65.6913 96.7443 58.8707 96.6698L57.4538 100.429C57.1871 101.122 56.7688 101.666 56.205 102.019Z",
    fill: "#A56663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5043 48.9216C45.2598 52.3601 44.4878 55.1758 45.2608 64.9051C46.0343 74.6343 40.7768 83.5381 49.5457 93.5458C55.4543 100.283 67.0278 102.985 77.2617 97.8988C80.719 96.1811 84.0387 93.5853 86.9373 89.9866C89.2143 87.1621 91.7634 84.5467 94.5309 82.2191C98.359 79.0484 103.364 72.3013 103.149 59.1255C102.819 37.6854 82.3576 32.4351 69.7682 33.0745C57.1787 33.7138 49.8524 39.8424 46.5043 48.9216Z",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6047 70.9361C84.6047 70.9361 86.778 64.7893 92.8311 66.3914C98.0523 67.7935 98.1643 80.7834 85.6182 82.6745",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7884 76.9491C86.7884 76.9491 88.4393 76.187 88.5016 74.4771C88.5199 72.4604 88.9403 71.272 89.9202 71.0195C92.3723 70.3671 92.4667 73.1296 92.3361 73.4554",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0524 76.6343C54.0524 76.6343 52.4383 76.4993 51.1683 74.4781C50.4635 73.3504 49.9198 71.9872 50.4357 71.6712C50.9573 71.3129 58.4287 73.5387 58.7961 74.6202C59.1636 75.7016 55.9922 76.9 54.0524 76.6343Z",
    fill: "#A56663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7269 62.2917C54.7269 62.2917 54.0942 66.2865 50.9097 70.4044C49.4997 72.2306 50.7841 75.7145 54.4623 76.7767",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8504 105.506C41.8504 105.506 49.2244 100.286 55.8787 99.6939C55.8787 99.6939 53.63 110.47 61.4149 110.72C73.9922 111.11 87.4751 99.5515 87.4751 99.5515C87.4751 99.5515 95.3025 102.943 101.194 108.862C101.194 108.862 98.536 121.688 82.8563 126.071C67.1765 130.455 46.9877 124.469 42.6617 119.666C38.3358 114.863 40.4428 106.689 41.8504 105.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44 112.142C104.44 112.142 112.003 117.774 114.713 131.249C117.422 144.723 114.674 163.852 114.674 163.852L18.439 150.676C18.439 150.676 25.4622 119.459 36.4361 110.222C36.4361 110.222 34.5108 119.581 53.0597 123.109C71.6088 126.636 94.9003 123.767 95.9219 120.384C96.913 116.911 104.44 112.142 104.44 112.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6429 152.573C51.452 168.428 96.57 163.35 96.57 163.35C96.57 163.35 98.9278 152.717 98.3729 132.921C98.3676 132.018 98.3623 131.116 98.3877 130.302C98.6608 121.404 101.637 115.668 104.434 112.184C104.567 111.214 103.647 110.401 102.641 109.275C102.229 108.832 94.626 102.55 94.254 102.757C93.5481 103.519 92.8844 104.288 92.2993 105.11C86.3809 113.192 83.4545 122.329 73.4438 122.334C63.5597 122.356 54.2265 120.863 47.7233 118.469C41.4673 116.152 47.2353 106.029 50.8247 101.15C50.9801 100.956 50.9916 100.873 51.1297 100.805C50.2464 100.04 37.8034 107.143 36.4784 110.227C33.9883 114.612 33.008 118 31.8421 122.438C28.0024 136.992 26.6429 152.573 26.6429 152.573Z",
    fill: "#77A0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5088 124.232C88.0182 124.029 86.9753 122.654 87.1793 121.164C87.3835 119.673 88.7572 118.63 90.2478 118.834C91.7384 119.039 92.7814 120.412 92.5773 121.903C92.3733 123.393 90.9994 124.436 89.5088 124.232Z",
    fill: "#647184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0431 118.483C37.6915 118.298 36.7465 117.054 36.9312 115.702C37.1169 114.351 38.3614 113.406 39.712 113.591C41.0636 113.777 42.0085 115.021 41.8239 116.372C41.6382 117.723 40.3937 118.668 39.0431 118.483Z",
    fill: "#647184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9773 126.628C63.5154 126.13 55.4855 125.159 48.9131 123.271C44.4877 122.022 39.9408 124.793 38.985 129.259C38.0784 133.689 37.2071 139.111 37.271 143.975C37.3387 154.467 74.2236 159.001 76.0553 150.015C77.0335 145.38 77.8483 141.626 78.6129 138.551C80.048 132.776 75.9276 127.099 69.9773 126.628Z",
    stroke: "#647184",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6914 110.441C59.6914 110.441 66.127 120.86 68.5867 120.466C71.0465 120.072 86.7902 114.28 90.9341 101.271C90.9341 101.271 89.5249 98.0711 88.0494 96.924C88.0494 96.924 82.5533 104.119 73.8998 107.703C65.6606 111.086 59.6914 110.441 59.6914 110.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6913 110.441C59.6913 110.441 66.1269 120.86 68.5867 120.466C71.0464 120.072 86.7902 114.28 90.9341 101.271",
    stroke: "#D0D6DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6912 110.441C59.6912 110.441 52.7444 116.621 50.7508 116.435C48.7572 116.248 49.5997 103.818 56.4004 98.3905C56.4004 98.3905 57.2935 98.7706 57.6615 98.9072C57.7094 98.8708 53.4855 107.443 59.6912 110.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.647 110.767C59.647 110.767 52.8687 116.514 50.9113 116.327C48.9538 116.139 49.7036 104.499 56.3432 99.4573",
    stroke: "#D0D6DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1898 111.196C60.1898 111.196 61.1917 112.666 60.3773 115.475C59.5688 118.243 59.2662 121.08 59.2662 121.08",
    stroke: "#D0D6DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1722 117.227C56.6365 117.155 56.2616 116.661 56.335 116.125C56.4084 115.589 56.9021 115.215 57.4377 115.287C57.9734 115.361 58.3483 115.855 58.2749 116.391C58.2016 116.926 57.7078 117.301 57.1722 117.227Z",
    fill: "#D0D6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.104 68.5737C70.1219 68.6701 70.9964 67.9305 71.0506 66.9069L71.1701 65.7204C71.2665 64.7024 70.5271 63.8279 69.5033 63.7737C68.4854 63.6773 67.6109 64.4168 67.5567 65.4404L67.4371 66.627C67.3466 67.6028 68.086 68.4773 69.104 68.5737Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.263 66.7755C52.1966 66.8604 53.0231 66.1573 53.108 65.2237L53.216 64.1215C53.3008 63.188 52.5977 62.3613 51.6642 62.2765C50.7306 62.1917 49.904 62.8948 49.8191 63.8283L49.7112 64.9305C49.6264 65.8641 50.3295 66.6906 51.263 66.7755Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3482 65.5675C65.3482 65.5675 66.6583 64.1573 68.5964 64.1219C70.1914 64.0825 71.8164 65.0783 71.9482 65.9986",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8559 64.2439C52.8559 64.2439 53.0405 62.8945 51.1007 62.6289C49.4982 62.4094 48.6213 63.7931 48.6213 63.7931",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5488 58.5415C63.6228 58.7155 62.8469 57.7929 63.1484 56.8461C63.302 56.3515 63.5822 55.8744 64.0558 55.5526C65.4769 54.5872 70.8447 54.2909 73.8055 56.2C76.4041 57.9305 68.7821 57.7463 64.5488 58.5415Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.847 57.49C52.5293 57.8412 53.3923 57.186 53.3871 56.2831C53.4084 55.8134 53.3032 55.3264 53.0121 54.9429C52.1386 53.7922 48.7901 52.5175 46.3837 53.7776C44.307 54.8251 48.7251 55.8166 51.847 57.49Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7774 81.8591C55.6428 82.528 55.9873 83.7781 56.7995 84.7486C61.9633 82.4912 63.9062 84.3037 63.9062 84.3037C65.9452 81.9623 66.0449 78.4101 61.5905 80.5068C58.4746 81.9277 56.7051 81.9861 55.7774 81.8591Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.799 84.749C57.6899 85.7731 59.1329 86.5293 61.3148 85.9687C62.3368 85.722 63.1998 85.0668 63.9056 84.3043C63.9056 84.3043 61.9627 82.4916 56.799 84.749Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9986 81.5811C54.9986 81.5811 56.637 82.7935 61.5899 80.5073C67.5092 77.7519 65.4082 84.9396 61.357 85.9745C57.1255 87.0707 55.5499 83.2032 55.7769 81.8595",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9056 84.3043C63.9056 84.3043 61.9627 82.4916 56.799 84.749",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1768 81.9463C38.2424 76.1015 35.0363 74.4167 37.6344 69.8748C41.4711 63.1825 41.3994 62.1416 41.2816 60.4929C40.3848 48.2119 40.5066 35.0823 56.312 29.47C74.1053 23.1419 96.8625 29.8233 104.053 41.6342C110.167 51.5791 107.375 55.9656 108.364 62.5454C109.341 68.9085 117.499 70.1972 112.013 82.3349C109.238 88.4851 116.409 92.9039 113.244 103.469C100.757 107.13 88.1444 107.937 75.5155 106.981C73.2486 98.1219 84.0512 97.6675 85.8926 85.16C86.008 84.3166 86.0756 83.5096 86.0951 82.7389C98.2789 80.6693 98.0901 67.9267 92.9112 66.5303C89.3058 65.5641 87.083 67.3649 85.8763 68.9612C85.7573 69.2026 85.6019 69.3962 85.4407 69.6319C83.463 72.1536 75.3272 68.505 70.5405 61.1047C65.3956 53.1828 65.7844 53.7944 63.289 49.1136C58.2561 39.7464 57.2239 48.5411 55.5019 49.5082C53.0838 50.8527 54.3081 52.2662 50.1185 57.4495C48.2539 59.772 45.1301 61.879 45.3943 64.9655C46.1736 74.6527 40.9103 83.5985 49.6793 93.6062C51.6488 95.8521 54.5386 97.9663 58.1093 99.1852C57.7674 100.428 57.0073 102.213 55.5974 104.04C47.033 102.266 38.5135 99.8531 30.0277 97.1882C29.3195 92.3225 30.7566 86.8482 34.1768 81.9463Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4044 69.5838C85.5597 69.3902 85.7209 69.1546 85.8398 68.913C85.6788 69.1488 85.5176 69.3844 85.4044 69.5838Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1537 64.6235C44.1537 64.6235 33.5167 59.4726 39.2001 49.3384C42.3276 43.7519 43.3728 37.064 46.365 33.0916C50.5107 27.6016 56.0668 26.5578 63.6855 29.2764C76.7934 33.9494 55.3511 27.7058 52.6679 37.2626C50.0269 46.8252 44.1537 64.6235 44.1537 64.6235Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.7051 71.7864C50.7051 71.7864 49.8064 74.5848 46.2786 75.5626C45.3894 75.7845 44.578 75.1149 44.7057 74.1872C44.7479 74.193 50.448 72.095 50.7051 71.7864Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M59.6646 65.9672C59.6646 65.9672 57.335 62.8987 56.0259 62.4188L59.4951 63.753L59.6646 65.9672Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M76.7253 75.349C76.7253 75.349 74.68 78.6777 69.8835 78.8803C65.0812 79.125 61.2838 75.1682 60.0754 69.2458C60.0754 69.2458 60.962 74.6945 67.2392 76.542C73.4628 78.4681 76.7253 75.349 76.7253 75.349Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M71.7692 55.3805C77.7153 56.1946 81.8838 61.8347 81.0945 67.9132C80.7019 70.7809 79.2897 73.2511 77.3008 74.9121L64.1116 57.3394C66.2633 55.7437 68.9437 54.9936 71.7692 55.3805Z",
    fill: "#DBC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M64.1107 57.3394L77.3 74.9121C75.0657 76.7973 72.1455 77.7294 69.1092 77.3137C63.2474 76.5112 59.1038 71.0032 59.7607 64.9496C60.1094 61.7752 61.7672 59.0808 64.1107 57.3394Z",
    fill: "#C4ADD8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M47.0985 52.0028C51.6109 52.6205 54.725 58.1164 54.0622 64.2121C53.8117 66.6696 52.9576 68.8296 51.7815 70.516L40.2257 55.4439C41.9761 53.0199 44.4838 51.6448 47.0985 52.0028Z",
    fill: "#DBC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M40.2315 55.4019L51.787 70.4739C50.0316 72.9402 47.5177 74.3575 44.8609 73.9938C40.4329 73.3875 37.3014 68.0182 37.8741 61.9531C38.1305 59.4534 39.0017 57.1668 40.2315 55.4019Z",
    fill: "#C4ADD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7552 64.9919C59.056 71.0397 63.2418 76.5534 69.1036 77.3559C74.9654 78.1584 80.3104 73.9496 81.136 67.9191C81.9253 61.8407 77.7568 56.2004 71.8107 55.3864C65.8645 54.5723 60.4179 58.8961 59.7552 64.9919Z",
    stroke: "#4EC2DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8682 61.995C37.2956 68.0602 40.427 73.4296 44.8551 74.0357C49.2834 74.642 53.4054 70.2657 54.0623 64.2121C54.7251 58.1164 51.611 52.6205 47.0986 52.0028C42.5861 51.3849 38.4468 55.8877 37.8682 61.995Z",
    stroke: "#4EC2DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1713 66.7205L87.1597 67.5404",
    stroke: "#4EC2DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8749 63.8053C59.8749 63.8053 55.1221 61.1784 54.2239 63.0316",
    stroke: "#4EC2DD",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3807 78.9109L87.4675 80.2466C87.3064 80.4824 87.0302 80.6164 86.7715 80.6239L85.1343 80.6576C84.4058 80.6437 84.0315 81.4947 84.4683 82.0701L85.4511 83.3645C85.633 83.6043 85.6827 83.8689 85.6002 84.1583L85.1277 85.7262C84.9031 86.4258 85.5928 87.0357 86.2659 86.8271L87.8036 86.2644C88.0739 86.1725 88.3691 86.2129 88.6049 86.3741L89.9347 87.3294C90.5212 87.7534 91.3553 87.3091 91.3269 86.5749L91.2933 84.9377C91.2915 84.6368 91.4105 84.3953 91.6503 84.2133L92.9448 83.2305C93.5201 82.7937 93.3404 81.9099 92.6829 81.691L91.1151 81.2186C90.8257 81.1361 90.6379 80.9384 90.546 80.6681L90.0254 79.1362C89.696 78.4037 88.7683 78.2767 88.3807 78.9109Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3994 77.4274C42.5812 77.6672 42.6254 77.9739 42.5488 78.2212L42.0763 79.789C41.8513 80.4886 42.535 81.1407 43.2137 80.89L44.1214 80.5416C44.1086 78.4348 44.3129 76.3147 44.5594 74.2003L44.4524 74.3574C44.2913 74.5932 44.0153 74.7272 43.756 74.7347L42.1244 74.7262C41.3966 74.7124 40.9801 75.5575 41.4584 76.1387L42.3994 77.4274Z",
    fill: "#FFDE55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingAvatarAlice);
export default __webpack_public_path__ + "static/media/pricing_avatar_alice.c3e1d2beed932b4f2c0c9ac4bf369bfe.svg";
export { ForwardRef as ReactComponent };